export default __webpack_public_path__ + "static/media/LMNTLfire2-icon.b0806492.png";